import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Breadcrumb }from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import Collapsible from './collapsible'
import Loadable from 'react-loading-overlay'

@observer(['activities', 'agreements', 'quotes', 'companies', 'quickbooks', 'globals'])

export default class Quote extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loadableState: true
    }

    let quoteId = this.props.params.quoteId

    this.props.quickbooks.getQuickbooksCompanyItems((qbItemArray) => {
      this.props.quickbooks.getQuickbooksTerms((qbTermsArray) => {
        this.props.quickbooks.getQuickbooksTaxRates((qbTaxRatesArray) => {
          this.loadQuoteDetails(quoteId, qbItemArray, qbTermsArray, qbTaxRatesArray)
        })
      })
    })
  }

  loadQuoteDetails(quoteId, qbItemArray, qbTermsArray, qbTaxRatesArray) {
    this.props.quotes.loadQuote(quoteId, qbItemArray, qbTermsArray, qbTaxRatesArray, (data) => {
      console.log(this.props.quotes.quoteDetail)
      let row = {
        id: data.companyId
      }
      this.props.companies.loadCompanyDetails(row)

      if (data.agreementId > 0) {
        this.props.agreements.loadAgreement(data.agreementId)
      }

      //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
      this.props.activities.logNewActivity(localStorage.getItem('userId'), 'read', 1, quoteId, 1, data.companyId)
    })

    this.props.quotes.loadQuoteHardware(quoteId, qbItemArray)

    this.setState({
      loadableState: false
    })
  }

  formatTaxExempt(cell, row) {
    return (cell == 1 ? 'Yes' : 'No')
  }

  render() {

    let hardwareList = ''
    //let monthlyList = ''
    //let accessoriesList = ''
    //let featuresList = ''
    let subtotal = 0
    let oneTimeTotal = 0
    let servicesTotal = 0
    let taxTotal = this.props.quotes.quoteDetail.taxTotal
    let shippingCost = this.props.quotes.quoteDetail.shippingCost

    if (this.props.quotes.quoteHardware.length > 0) {
      hardwareList = this.props.quotes.quoteHardware.map((hw) => {
        subtotal += parseFloat(hw.cost) * parseFloat(hw.quantity)
        return (<tr>
          <td>{ hw.quantity }</td>
          <td>{ hw.hardwareName }</td>
          <td>{ hw.hardwareDescription }</td>
          <td>${ hw.cost.toFixed(2) }</td>
          <td>${ (hw.quantity * hw.cost).toFixed(2) }</td>
        </tr>)
      })

      /*
      monthlyList = this.props.quotes.quoteHardware.map((hw) => {
        servicesTotal += parseFloat(hw.serviceCost) * parseFloat(hw.quantity)
        return (<tr>
          <td>{ hw.quantity }</td>
          <td>{ this.props.quotes.quoteDetail.serviceName }</td>
          <td>{ this.props.quotes.quoteDetail.serviceDescription }</td>
          <td>${ hw.serviceCost.toFixed(2) }</td>
          <td>${ (hw.quantity * hw.serviceCost).toFixed(2) }</td>
        </tr>)
      })
      */
    }

    let notesTable = ''

    if (this.props.quotes.quoteDetail.note) {
      notesTable = 
        <table style={{ width: '90%', margin: '5%' }}>
          <tbody>
            <tr>
              <td style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }} colSpan={ 3 }><b>Notes</b></td>
            </tr>
            <tr>
              <td colSpan={ 3 } style={{ paddingTop: '25px', whiteSpace: 'pre-wrap' }}>{ this.props.quotes.quoteDetail.note }</td>
            </tr>
          </tbody>
        </table>
    }

    let serialNumbersTable = ''

    if (this.props.quotes.quoteDetail.serialNumbers) {
      serialNumbersTable =
        <table style={{ width: '90%', margin: '5%' }}>
          <tbody>
            <tr>
              <td style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }} colSpan={ 3 }><b>Serial Numbers</b></td>
            </tr>
            <tr>
              <td colSpan={ 3 } style={{ paddingTop: '25px', whiteSpace: 'pre-wrap' }}>{ this.props.quotes.quoteDetail.serialNumbers }</td>
            </tr>
          </tbody>
        </table>
    }

    let termsTable = ''

    if (this.props.quotes.quoteDetail.agreementId > 0) {
      termsTable = 
        <div>
          <table style={{ width: '90%', margin: '5%' }}>
            <tbody>
              <tr>
                <td style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }} colSpan={ 3 }><b>TERMS AND CONDITIONS</b></td>
              </tr>
              <tr>
                <td colSpan={ 3 } style={{ paddingTop: '25px', whiteSpace: 'pre-wrap' }}>{ this.props.agreements.agreementDetail.agreement }</td>
              </tr>
              <tr>
                <td style={{ paddingTop: '50px', width: '70px' }}>Print Name:</td>
                <td style={{ paddingTop: '50px' }}>__________________________________________________________</td>
                <td style={{ paddingTop: '50px' }}></td>
              </tr>
              <tr>
                <td style={{ paddingTop: '50px', width: '70px' }}>Signature:</td>
                <td style={{ paddingTop: '50px' }}>__________________________________________________________</td>
                <td style={{ paddingTop: '50px' }}></td>
              </tr>
              <tr>
                <td style={{ paddingTop: '50px', width: '70px' }}>Title:</td>
                <td style={{ paddingTop: '50px' }}>__________________________________________________________</td>
                <td style={{ paddingTop: '50px' }}></td>
              </tr>
              <tr>
                <td style={{ paddingTop: '50px', width: '70px' }}>Date:</td>
                <td style={{ paddingTop: '50px' }}>__________________________________________________________</td>
                <td style={{ paddingTop: '50px' }}></td>
              </tr>
            </tbody>
          </table>
        </div>
    }

    /*
    if (this.props.quotes.quoteAccessory.length > 0) {
      accessoriesList = this.props.quotes.quoteAccessory.map((acc) => {
        subtotal += parseFloat(acc.cost) * parseFloat(acc.quantity)
        return (<tr>
          <td>{ acc.quantity }</td>
          <td>{ acc.accessoryName }</td>
          <td>{ acc.accessoryDescription }</td>
          <td>${ acc.cost.toFixed(2) }</td>
          <td>${ (acc.quantity * acc.cost).toFixed(2) }</td>
        </tr>)
      })
    }

    if (this.props.quotes.quoteFeature.length > 0) {
      featuresList = this.props.quotes.quoteFeature.map((f) => {
        servicesTotal += parseFloat(f.cost) * parseFloat(f.quantity)
        return (<tr>
          <td>{ f.quantity }</td>
          <td>{ f.featureName }</td>
          <td>{ f.featureDescription }</td>
          <td>${ f.cost.toFixed(2) }</td>
          <td>${ (f.quantity * f.cost).toFixed(2) }</td>
        </tr>)
      })
    }
    */

    let today = new Date()

    return (
      <div className="right_col" role="main">
        <div className="">
          <div className="page-title hidden-print">
            <div className="title_left">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item href="/quotes">Quotes</Breadcrumb.Item>
              <Breadcrumb.Item active>Quote #: { this.props.quotes.quoteDetail.id }</Breadcrumb.Item>
            </Breadcrumb>
            </div>
          </div>
          <Loadable active={ this.state.loadableState } spinner text='Processing your request...'>
            <div style={{ height: 'inherit' }} >
              <table style={{ width: '90%', margin: '5%'}}>
                <tbody>
                  <tr>
                    <td colSpan={ 4 } style={{ textAlign: 'center' }}>
                      <img src="/images/logo-white.png" /><br />
                      <small>30724 Benton Road Suite C 302-413<br />Winchester, CA 92596</small>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={ 4 } style={{ paddingTop: '30px', fontSize: '150%', textAlign: 'center' }}><b>{ this.props.quotes.quoteDetail.demoName + ' ' + this.props.quotes.quoteDetail.leaseName + ' Quote # ' + this.props.quotes.quoteDetail.id}</b></td>
                  </tr>
                  <tr>
                    <td style={{ paddingTop: '30px' }}>Date: { this.props.quotes.quoteDetail.formattedQuoteDate }</td>
                    <td style={{ paddingTop: '30px' }}>Rep: { this.props.quotes.quoteDetail.userFullName }</td>
                    <td style={{ paddingTop: '30px' }}>Contract Term: { this.props.quotes.quoteDetail.contractTermName }</td>
                    <td style={{ paddingTop: '30px' }}>Payment Term: { this.props.quotes.quoteDetail.paymentTermName }</td>
                  </tr>
                  <tr>
                    <td colSpan={ 2 } style={{ paddingTop: '30px' }}><b>Bill To</b></td>
                    <td colSpan={ 2 } style={{ paddingTop: '30px' }}><b>Ship To</b></td>
                  </tr>
                  <tr>
                    <td style={{ paddingTop: '15px' }}><small><b>Company</b></small></td>
                    <td style={{ paddingTop: '15px' }}><small>{ this.props.companies.details.name }</small></td>
                    <td style={{ paddingTop: '15px' }}><small><b>Company</b></small></td>
                    <td style={{ paddingTop: '15px' }}><small>{ this.props.companies.details.name }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>Name</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.billingAddressName }</small></td>
                    <td><small><b>Name</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.shippingAddressName }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>Address</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.billingAddressAddress }</small></td>
                    <td><small><b>Address</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.shippingAddressAddress }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>City</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.billingAddressCity }</small></td>
                    <td><small><b>City</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.shippingAddressCity }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>State</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.billingAddressState }</small></td>
                    <td><small><b>State</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.shippingAddressState }</small></td>
                  </tr>
                  <tr>
                    <td><small><b>Zip</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.billingAddressZipCode }</small></td>
                    <td><small><b>Zip</b></small></td>
                    <td><small>{ this.props.quotes.quoteDetail.shippingAddressZipCode }</small></td>
                  </tr>
                  <tr>
                    <td style={{ paddingTop: '30px' }}></td>
                  </tr>
                  <tr>
                    <td colSpan={ 4 } style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }}><b>Items</b></td>
                  </tr>
                  <tr>
                    <td colSpan={ 4 }>
                      <table style={{ width: '100%' }}>
                        <tbody>
                          <tr>
                            <td><b>QTY</b></td>
                            <td><b>Item</b></td>
                            <td><b>Description</b></td>
                            <td><b>Price</b></td>
                            <td><b>Total</b></td>
                          </tr>
                          { hardwareList }
                          { /* accessoriesList */ }
                          <tr>
                            <td style={{ paddingTop: '30px' }} colSpan={ 3 }></td>
                            <td style={{ paddingTop: '30px', textAlign: 'right' }}><b>SUBTOTAL:</b>&nbsp;&nbsp;</td>
                            <td style={{ paddingTop: '30px' }}>${ subtotal.toFixed(2) }</td>
                          </tr>
                          { /*
                          <tr>
                            <td style={{ paddingTop: '30px' }} colSpan={ 3 }></td>
                            <td style={{ paddingTop: '30px', textAlign: 'right' }}><b>Activation Fees:</b>&nbsp;&nbsp;</td>
                            <td style={{ paddingTop: '30px' }}>${ (this.props.quotes.quoteDetail.activation > 0) ? this.props.quotes.quoteDetail.activation : '0.00' }</td>
                          </tr>
                           */ }
                          <tr>
                            <td colSpan={ 3 }></td>
                            <td style={{ textAlign: 'right' }}><b>TAX:</b>&nbsp;&nbsp;</td>
                            <td>${ taxTotal }</td>
                          </tr>
                          <tr>
                            <td colSpan={ 3 }></td>
                            <td style={{ textAlign: 'right' }}><b>SHIPPING:</b>&nbsp;&nbsp;</td>
                            <td>${ shippingCost }</td>
                          </tr>
                          <tr>
                            <td colSpan={ 3 }></td>
                            <td style={{ textAlign: 'right' }}><b>TOTAL:</b>&nbsp;&nbsp;</td>
                            <td>${ (parseFloat(subtotal) + parseFloat(taxTotal) + parseFloat(shippingCost)).toFixed(2) }</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  { /*
                  <tr>
                    <td style={{ paddingTop: '30px' }}></td>
                  </tr>
                  <tr>
                    <td colSpan={ 4 } style={{ fontSize: '125%', textAlign: 'center', backgroundColor: '#efefef' }}><b>{ this.props.quotes.quoteDetail.paymentIntervalName } Fees</b></td>
                  </tr>
                  <tr>
                    <td colSpan={ 4 }>
                    <table style={{ width: '100%' }}>
                      <tbody>
                        <tr>
                          <td><b>QTY</b></td>
                          <td><b>Item</b></td>
                          <td><b>Description</b></td>
                          <td><b>Price</b></td>
                          <td><b>Total</b></td>
                        </tr>
                        { monthlyList }
                        { featuresList }
                        <tr>
                          <td colSpan={ 3 }></td>
                          <td style={{ textAlign: 'right' }}><b>TOTAL:</b>&nbsp;&nbsp;</td>
                          <td>${ servicesTotal.toFixed(2) }</td>
                        </tr>
                      </tbody>
                    </table>
                    </td>
                  </tr>
                  */ }
                </tbody>
              </table>
            </div>
            <div>
              {notesTable}
            </div>
            <div className="pagebreak-print">
              {serialNumbersTable}
            </div>
            <div className="clearfix"></div>
              {termsTable}
            </Loadable>
            <div className="clearfix"></div>
          </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/quote.js